export default __webpack_public_path__ + "static/media/IMG_20220313_153838_601.0ab65958.jpg";